'use client';

import { usePathname } from 'next/navigation';
import type { SceneId } from './types';

// Maps the current pathname to a scene id. /contact is the only sand route;
// /admin gets neither scene (its surface is already dense/functional);
// /koi-debug mounts its own KoiPondScene explicitly with debugCamera, so
// the BackgroundProvider must suppress its default pond on that route to
// avoid two KoiScene3D instances + two WebGL renderers competing for
// chromium's per-page context budget (2026-05-24 prod audit: the
// double-mount fired the "different type" context-creation error
// intermittently during /↔/koi-debug navigation).
export function usePondPathname(): SceneId | null {
  const pathname = usePathname() ?? '/';
  if (pathname.startsWith('/admin')) return null;
  if (pathname.startsWith('/koi-debug')) return null;
  if (pathname === '/contact' || pathname.startsWith('/contact/')) return 'sand';
  if (pathname === '/book' || pathname.startsWith('/book/')) return 'pond-still';
  return 'pond';
}
